import { useEffect, useState } from 'react';

import { PatronSessionState } from '@app/components';
import { setAxiosHeaders } from '@app/utils';
import { SetState, UserSession } from '@app/constants';

import {
  useRecentActivityTransfer,
  useSavedActivityTransfer,
  useSessionValidation,
} from '../requests';

interface AppUsersProps {
  patronSession: PatronSessionState;
  isConsortiaLogin: boolean;
  setPatronSession: SetState<PatronSessionState>;
  setIsOkapiSessionDown: SetState<boolean>;
}

export const useAppUsers = ({
  patronSession,
  isConsortiaLogin,
  setPatronSession,
  setIsOkapiSessionDown,
}: AppUsersProps) => {
  const [isPatronUserLoggedIn, setIsPatronUserLoggedIn] = useState(false);
  const patronUser = useSessionValidation({
    userSessionKey: UserSession.patron,
    isConsortiaLogin,
    setIsOkapiSessionDown,
    setPatronSession,
  });
  const { transfer: transferRecentActivity } = useRecentActivityTransfer();
  const {
    transfer: transferSavedActivity,
    isLoading: isTransferSavedActivityLoading,
  } = useSavedActivityTransfer();

  useEffect(() => {
    if (patronUser.isLoggedIn && Boolean(patronUser.session?.user)) {
      setAxiosHeaders(patronUser.session);
      setPatronSession(patronUser.session);
      setIsPatronUserLoggedIn(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patronUser.isLoggedIn, setPatronSession]);

  const authenticateToken = (token: string, redirectRoute: string) => {
    patronUser.validateToken({ token, redirectRoute });
  };

  useEffect(() => {
    setIsPatronUserLoggedIn(Boolean(patronSession?.user));
  }, [patronSession?.user]);

  useEffect(() => {
    const externalSystemId = patronSession?.user?.externalSystemId;

    if (isPatronUserLoggedIn && externalSystemId) {
      transferRecentActivity(externalSystemId);
      transferSavedActivity(externalSystemId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPatronUserLoggedIn]);

  return {
    isTransferSavedActivityLoading,
    isPatronUserLoggedIn,
    authenticateToken,
  };
};
